module.exports = __webpack_public_path__ + "gamecode/img/beast_favicon.png?d36bd284";